import { __decorate, __metadata } from "tslib";
// NPM
import PageHeader from "@/components/page-header.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Layout from "@/router/layouts/main.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { IntegrationConfigurationModel } from "@/store/models/organizationSetting/integrationConfigurations";
import { OrganizationSettings } from "@/store/modules/organizationSetting.module";
import { toaster } from "@/utilities/toaster";
import { setInteractionMode } from "vee-validate";
import { Component, Mixins, Prop } from "vue-property-decorator";
import EmptyProviderComponent from "./EmptyProviderComponent.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let CalendarProviderComponent = /** @class */ (() => {
    let CalendarProviderComponent = class CalendarProviderComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.apiConfiguration = new IntegrationConfigurationModel();
            this.selectedProviderId = null;
        }
        get externalApiConfiguration() {
            return OrganizationSettings.externalApiConfiguration;
        }
        selected(providerId) {
            this.selectedProviderId = providerId;
            OrganizationSettings.SaveCalendarConfiguration(providerId).then((res) => {
                toaster.ShowSuccess("Provider was updated sucessfully.");
            });
        }
        created() {
            OrganizationSettings.GetSelectedCalendarProvider().then((res) => {
                if (res) {
                    if (this.externalApiConfiguration != null) {
                        this.selectedProviderId = this.externalApiConfiguration.providerId;
                    }
                    else {
                        if (this.externalApiProviders.length > 0) {
                            this.selectedProviderId = this.Constant.Providers.EmptyCalendarIntegrationProvider();
                        }
                    }
                }
            });
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], CalendarProviderComponent.prototype, "externalApiProviders", void 0);
    CalendarProviderComponent = __decorate([
        Component({
            name: "CalendarProviderComponent",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
                EmptyProviderComponent,
            },
        })
    ], CalendarProviderComponent);
    return CalendarProviderComponent;
})();
export default CalendarProviderComponent;
